import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20lifestyle%20composition%20with%20carefully%20curated%20clothing%20pieces%20and%20accessories%20arranged%20on%20a%20warm%20cream%20surface%2C%20soft%20diffused%20natural%20daylight%20from%20large%20windows%2C%20elegant%20textile%20textures%20in%20beige%20and%20terracotta%20tones%2C%20clean%20editorial%20aesthetic%20with%20organic%20gentle%20shadows%2C%20peaceful%20modern%20atmosphere&width=1600&height=900&seq=hero-fashion-bg&orientation=landscape"
          alt="Sugargoo Spreadsheet shopping resource background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 py-20 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-semibold text-white mb-5 leading-tight">
          Sugargoo Spreadsheet
          <span className="block text-xl md:text-2xl lg:text-3xl font-body font-light mt-3 opacity-90">
            The Ultimate Sugargoo Shopping Resource Hub
          </span>
        </h1>

        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          Discover thousands of organized Sugargoo finds, product spreadsheets, reviews, shipping guides, coupons, and expert shopping tips — all in one place.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg text-base transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Sugargoo Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/20 hover:bg-white/30 text-white font-semibold rounded-lg text-base backdrop-blur-sm border border-white/30 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8">
          {[
            { icon: 'ri-check-line', text: 'Updated Spreadsheet Resources' },
            { icon: 'ri-guide-line', text: 'Complete Shopping Guides' },
            { icon: 'ri-ship-line', text: 'Shipping Cost Information' },
            { icon: 'ri-star-line', text: 'Independent Reviews' },
          ].map((badge) => (
            <div key={badge.text} className="flex items-center gap-2 text-white/70 text-xs md:text-sm">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={badge.icon}></i>
              </span>
              <span className="whitespace-nowrap">{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}